// TODO: @lachy Category refactor
export enum CategoryParent {
  AddOnType = 'add-on-type',
  AssetCondition = 'asset-condition',
  AssetType = 'asset-type',
  AssetTypeConsumer = 'asset-type-consumer',
  AssetTypeCAL = 'asset-type-cal',
  Countries = 'countries',
  CountryMobileCodes = 'country-mobile-codes',
  DocumentType = 'document-type',
  DocumentTypeConsumerAutoLoan = 'document-type-consumer-auto-loan',
  DocumentTypeChattelMortgage = 'document-type-chattel-mortgage',
  DocumentTypeConsumerLoan = 'document-type-consumer-loan',
  DocumentTypeSecuredPersonalLoan = 'document-type-secured-personal-loan',
  Gender = 'gender',
  Industry = 'industry',
  LoanTermInMonths = 'loan-term-in-months',
  RelationshipToApplicantEntity = 'relationship-to-applicant-entity',
  States = 'states',
  TrusteeType = 'trustee-type',
}
